import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig.js";

import { getQueryParamsFromObject } from "../utils/getQueryParamsFromObject";
import { getReportPath } from "../utils/getReportPath";
import { isInsightsSupportedReportType } from "../utils/isInsightsSupportedReportType";

const fetchReportInsights = async (tenantVal, reportType, filters) => {
  const axiosInstance = createAxiosInstance();
  const url = `${tenantVal}/reports/${getReportPath(reportType)}/summary${getQueryParamsFromObject(filters)}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

// Dashboard widgets (stat cards / charts) for a report tab — same filters as the row-level table,
// fetched as a separate, independent query so the two panels load/refresh without blocking each other.
export const useReportInsights = ({ tenantVal, reportType, filters }) => {
  const { data, isFetching, isError } = useQuery({
    queryKey: ["report-insights", reportType, filters],
    queryFn: () => fetchReportInsights(tenantVal, reportType, filters),
    enabled: isInsightsSupportedReportType(reportType),
    placeholderData: (previousData, previousQuery) => {
      const prevKey = previousQuery?.queryKey;
      if (!prevKey) return undefined;
      const sameType = prevKey[1] === reportType;
      const sameFilters = JSON.stringify(prevKey[2]) === JSON.stringify(filters);
      return sameType && sameFilters ? previousData : undefined;
    },
  });

  return {
    insights: data,
    isLoading: isFetching,
    isError,
  };
};
